import $ from 'jquery';

class CardCircle {
    constructor() {}

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.card-link-wrapper').on('click', (e) => {
            const target = e.currentTarget;
            const url = $(target).data('href');
            if (url.length > 0) {
                window.location = url;
            }
        });
    }
}


export default CardCircle;

$(() => {
	const cardCircle = new CardCircle();
	cardCircle.init();
});